import { computed } from 'vue'
import store from '@/store'
import EN from './en.png'
import HK from './hk.png'
import ID from './id.png'
import TH from './th.png'
import VI from './vi.png'

const langToImgMap = {
  en: EN,
  sg: EN,
  my: EN,
  ph: EN,
  hk: HK,
  tw: HK,
  id: ID,
  th: TH,
  vi: VI,
}

export default computed(() => langToImgMap[store.state.locale])
